import React, { useState, useEffect } from 'react';
import { Checkbox, FormControlLabel, FormGroup, Typography, Box } from '@mui/material';
import { useSnackbar } from 'notistack';
import apiClient from "../apiClient";

export interface MyCampaignComponentProps {
  campaignName: string[];
  setCampaignName: React.Dispatch<React.SetStateAction<string[]>>;
  disabled?: boolean;
  updateCampaignFilter: boolean;
};

interface CampaignProps {
  name: string;
  access_level: string;
};

export default function MyCampaignComponent(props: MyCampaignComponentProps) {
  const {
    campaignName,
    setCampaignName,
    disabled = false,
    updateCampaignFilter
  } = props;

  // handle response
  const [campaigns, setCampaigns] = useState<CampaignProps[]>([]);

  // notification snackbar
  const { enqueueSnackbar } = useSnackbar();

  const handleToggle = (item: string) => {
    setCampaignName((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  // get tag list
  useEffect(() => {
    if (!disabled) {
      const fetchData = async () => {
        try {
          // Backend now returns [{name, access_level}]
          const response = await apiClient.get('/sigcap/api/campaign-filter-list/');
          setCampaigns(response.data.campaign_list);
        } catch (err) {
          enqueueSnackbar('Failed to fetch campaign list', {
            variant: 'error',
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'center'
            }
          });
        }
      };
      fetchData();
    }
  }, [disabled, enqueueSnackbar, updateCampaignFilter]);

  // Split and sort campaigns
  const myCampaigns = campaigns
    .filter(c => c.access_level === 'private')
    .map(c => c.name)
    .filter(name => typeof name === 'string')
    .sort((a, b) => a.localeCompare(b));

  const sharedCampaigns = campaigns
    .filter(c => c.access_level === 'authenticated' || c.access_level === 'public')
    .map(c => c.name)
    .filter(name => typeof name === 'string')
    .sort((a, b) => a.localeCompare(b));

  return (
    <Box>
      {myCampaigns.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold">my campaigns</Typography>
          {myCampaigns.map(item => (
            <FormControlLabel
              key={item}
              control={
                <Checkbox
                  size="small"
                  checked={campaignName.includes(item)}
                  onChange={() => handleToggle(item)}
                />
              }
              label={item}
              sx={{
                display: 'flex',
                alignItems: 'center',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
              }}
            />
          ))}
        </Box>
      )}
      {sharedCampaigns.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" fontWeight="bold">shared campaigns</Typography>
          {sharedCampaigns.map(item => (
            <FormControlLabel
              key={item}
              control={
                <Checkbox
                  size="small"
                  checked={campaignName.includes(item)}
                  onChange={() => handleToggle(item)}
                />
              }
              label={item}
              sx={{
                display: 'flex',
                alignItems: 'center',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};
